import { Box, BoxProps } from '@mui/material';
import { useSettingsContext } from '../../components/settings';
import { HEADER, NAV } from '../../config-global';
import useResponsive from '../../hooks/useResponsive';
import { usePortalNotificationContext } from '../../portalNotification/context/PortalNotificationProvider';

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({ children, sx, showNotifications, ...other }: BoxProps & { showNotifications?: boolean }) {
  const { themeLayout } = useSettingsContext();

  const { childrenTopMargin } = usePortalNotificationContext()
  const notificationMargin = showNotifications ? childrenTopMargin : 0

  const isNavMini = themeLayout === 'mini';

  const isDesktop = useResponsive('up', 'lg');

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: `${HEADER.H_MOBILE + SPACING + notificationMargin}px`,
        ...(isDesktop && {
          px: 2,
          py: `${HEADER.H_DASHBOARD_DESKTOP + SPACING + notificationMargin}px`,
          width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_DASHBOARD_MINI}px)`,
          }),
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
